module.exports = __webpack_public_path__ + "img/ClockIcon.473f8aea.svg";